
import React from 'react';
import { Event } from '@/lib/types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import EventsGrid from './EventsGrid';
import EmptyEventsCard from './EmptyEventsCard';
import EventsLoadingSkeleton from './EventsLoadingSkeleton';
import EmptyTabContent from './EmptyTabContent';
import { EventStatus } from '@/services/eventService';

interface EventsTabsProps {
  events: Event[];
  isLoading: boolean;
  onViewDetails: (event: Event) => void;
  onEditEvent: (event: Event) => void;
  onCreateEvent?: () => void;
}

const EventsTabs = ({ events, isLoading, onViewDetails, onEditEvent, onCreateEvent }: EventsTabsProps) => {
  // Filter events by status
  const publishedEvents = events.filter(event => event.status === EventStatus.PUBLISHED);
  const draftEvents = events.filter(event => event.status === EventStatus.DRAFT);
  const archivedEvents = events.filter(event => event.status === EventStatus.ARCHIVED);

  return (
    <Tabs defaultValue="published">
      <TabsList className="mb-6">
        <TabsTrigger value="published">Közzétett események ({publishedEvents.length})</TabsTrigger>
        <TabsTrigger value="draft">Vázlatok ({draftEvents.length})</TabsTrigger>
        <TabsTrigger value="archived">Archivált ({archivedEvents.length})</TabsTrigger>
      </TabsList>

      <TabsContent value="published">
        {isLoading ? (
          <EventsLoadingSkeleton />
        ) : publishedEvents.length > 0 ? (
          <EventsGrid 
            events={publishedEvents} 
            onViewDetails={onViewDetails} 
            onEditEvent={onEditEvent} 
          />
        ) : (
          <EmptyEventsCard onCreateEvent={onCreateEvent} />
        )}
      </TabsContent>

      <TabsContent value="draft">
        {isLoading ? (
          <EventsLoadingSkeleton />
        ) : draftEvents.length > 0 ? (
          <EventsGrid 
            events={draftEvents} 
            onViewDetails={onViewDetails} 
            onEditEvent={onEditEvent} 
          />
        ) : (
          <EmptyTabContent message="Nincsenek vázlatok" />
        )}
      </TabsContent>

      <TabsContent value="archived">
        {isLoading ? (
          <EventsLoadingSkeleton />
        ) : archivedEvents.length > 0 ? (
          <EventsGrid 
            events={archivedEvents} 
            onViewDetails={onViewDetails} 
            onEditEvent={onEditEvent} 
          />
        ) : (
          <EmptyTabContent message="Nincsenek archivált események" />
        )}
      </TabsContent>
    </Tabs>
  );
};

export default EventsTabs;
